
<div class="problem-report-page">

  
    <!-- INTESTAZIONE PAGINA -->

    <div class="problem-report-page-header">
        <div class="page-header-content">
            <div class="page-header-icon">
            <i class="pi pi-exclamation-triangle"></i>
            </div>

            <div class="page-header-text">
            <h1>Richieste o segnalazioni</h1>
            <p>
                Seleziona un argomento e descrivi la tua richiesta.
                Ti aiuteremo a trovare una soluzione.
            </p>
            </div>
        </div>
    </div>


  <!-- CONTENUTO PRINCIPALE -->

  <div class="problem-report-card">

    <!-- INDICATORE PASSAGGI -->

    <div class="problem-report-steps">
      <div
        class="problem-report-step"
        [class.active]="isTopicSelection"
        [class.completed]="!isTopicSelection"
      >
        <span class="step-number">
          <i
            *ngIf="!isTopicSelection"
            class="pi pi-check"
          ></i>

          <ng-container *ngIf="isTopicSelection">
            1
          </ng-container>
        </span>

        <span>Argomento</span>
      </div>

      <div class="problem-report-step-line"></div>

      <div
        class="problem-report-step"
        [class.active]="!isTopicSelection"
      >
        <span class="step-number">2</span>
        <span>Descrizione</span>
      </div>
    </div>

    <!-- PASSAGGIO 1: ARGOMENTO -->

    <form
      *ngIf="isTopicSelection"
      [formGroup]="formGroupTopic"
      class="problem-report-form"
    >

      <div class="problem-report-section-heading">
        <div class="section-heading-icon">
          <i class="pi pi-list"></i>
        </div>

        <div class="section-heading-content">
          <h3>Seleziona un argomento</h3>

          <p>
            Scegli la categoria più adatta alla tua
            richiesta o segnalazione.
          </p>
        </div>
      </div>

      <div class="problem-report-topic-list">

        <div
          *ngFor="let topic of topics"
          class="problem-report-topic"
          [class.selected]="selectedTopic === topic"
          role="button"
          tabindex="0"
          [attr.aria-pressed]="selectedTopic === topic"
          (click)="selectTopic(topic)"
          (keydown.enter)="selectTopic(topic)"
          (keydown.space)="selectTopic(topic); $event.preventDefault()"
        >

          <div class="topic-icon">
            <i class="pi pi-file-edit"></i>
          </div>

          <div class="topic-content">
            <span class="topic-name">
              {{ topic.subject }}
            </span>
          </div>

          <div class="topic-selection-indicator">
            <i
              class="pi"
              [ngClass]="
                selectedTopic === topic
                  ? 'pi-check-circle'
                  : 'pi-circle'
              "
            ></i>
          </div>

        </div>

        <div
          *ngIf="topics.length === 0"
          class="problem-report-empty"
        >
          <i class="pi pi-inbox"></i>

          <p>Nessun argomento disponibile.</p>
        </div>

      </div>

    </form>

    <!-- PASSAGGIO 2: DESCRIZIONE -->

    <form
      *ngIf="!isTopicSelection"
      [formGroup]="formGroupDesc"
      class="problem-report-form"
    >

      <div class="problem-report-section-heading">
        <div class="section-heading-icon">
          <i class="pi pi-file-edit"></i>
        </div>

        <div class="section-heading-content">
          <h3>Descrivi la tua richiesta</h3>

          <p>
            Fornisci tutte le informazioni utili
            per permetterci di aiutarti.
          </p>
        </div>
      </div>

      <!-- ARGOMENTO SELEZIONATO -->

      <div class="problem-report-selected-topic">

        <div class="selected-topic-icon">
          <i class="pi pi-tag"></i>
        </div>

        <div class="selected-topic-content">
          <span class="selected-topic-label">
            Argomento selezionato
          </span>

          <strong>
            {{ selectedTopic?.subject }}
          </strong>
        </div>

      </div>

      <!-- DESCRIZIONE -->

      <div class="problem-report-description">

        <label for="problemDescription">
          Descrizione della richiesta
          <span class="required">*</span>
        </label>

        <textarea
          id="problemDescription"
          pInputTextarea
          formControlName="description"
          rows="8"
          placeholder="Scrivi qui la tua richiesta o segnalazione. Descrivi il problema o le informazioni di cui hai bisogno..."
          class="problem-report-textarea"
        ></textarea>

        <div class="description-help">
          <i class="pi pi-info-circle"></i>

          <span>
            Inserisci una descrizione chiara e completa.
          </span>
        </div>

      </div>

    </form>

    <!-- FOOTER AZIONI -->

    <div class="problem-report-footer">

      <ng-container *ngIf="isTopicSelection">

        <p-button
          label="Avanti"
          icon="pi pi-arrow-right"
          iconPos="right"
          [disabled]="formGroupTopic.invalid"
          (onClick)="goToDescription()"
          styleClass="problem-report-primary-button"
        ></p-button>

      </ng-container>

      <ng-container *ngIf="!isTopicSelection">

        <p-button
          label="Indietro"
          icon="pi pi-arrow-left"
          [outlined]="true"
          severity="secondary"
          [disabled]="submitting"
          (onClick)="goBack()"
          styleClass="problem-report-back-button"
        ></p-button>

        <p-button
          label="Invia segnalazione"
          icon="pi pi-check"
          iconPos="right"
          severity="success"
          [loading]="submitting"
          [disabled]="formGroupDesc.invalid || submitting"
          (onClick)="confirm()"
          styleClass="problem-report-submit-button"
        ></p-button>

      </ng-container>

    </div>

  </div>

</div>
